import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import PreguntaFormulario from "../components/formularios/PreguntaFormulario";
import { FaChevronRight, FaWpforms } from "react-icons/fa";
const FormularioDetails = () => {
  const { id } = useParams();
  const [preguntasList, setPreguntasList] = useState([]);
  const [serviciosList, setServiciosList] = useState([]);
  const [formularioData, setFormularioData] = useState(null);
  const [openPregunta, setOpenPregunta] = useState({ open: false, data: null });
  const [openAgregarPregunta, setOpenAgregarPregunta] = useState(false);

  const obtenerPreguntas = async () => {
    try {
      const respuestaPreguntas = await axios.get(
        `${BACKEND}/api/formularioServicioPregunta?where[formulario][equals]=${id}&limit=1000&sort=createdAt&where[active][not_equals]=false`
      );
      setPreguntasList(respuestaPreguntas.data?.docs);
    } catch (error) {
      console.log("Error al buscar preguntas", error);
    }
  };

  const obtenerDatosFormulario = async () => {
    try {
      const respuestaPreguntas = await axios.get(
        `${BACKEND}/api/formularioServicio/${id}`
      );
      setFormularioData(respuestaPreguntas.data);
    } catch (error) {
      console.log("Error al buscar formulario", error);
    }
  };

  const getServiciosList = async () => {
    try {
      const responsePlanes = await axios.get(
        `${BACKEND}/api/servicios?limit=1000`
      );
      setServiciosList(responsePlanes.data.docs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    obtenerPreguntas();
    obtenerDatosFormulario();
    getServiciosList();
  }, []);

  return (
    <div className="w-full mx-auto">

      {formularioData && (
        <div className="flex flex-row px-12 py-2 sm:flex-col overflow-x-auto bg-gray-100 mb-4">
            <div className="flex flex-row w-full items-center gap-4 justify-between">
                <div className="flex items-center gap-4 py-4">
                    <FaWpforms className="text-zinc-700 text-2xl" />

                    <Link to={'/home/formularios'}>
                        <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">Formularios</h2>
                    </Link>

                    <FaChevronRight className="text-orange-500 text-2xl" />


                    <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">{formularioData?.servicio.name} 
                        <span className="text-lg">
                            {formularioData.tipo === "entrada" && " (Formulario de entrada)"}
                            {formularioData.tipo === "satisfaccion" && " (Formulario de satisfaccion)"}
                        </span>
                    </h2>


                </div>
            </div>
        </div>
      )}

      <div className="py-10">
        <div className=" flex flex-col md:grid md:grid-cols-2 gap-2">
          {preguntasList.map((e) => (
            <PreguntaFormulario
              key={e.id}
              data={e}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FormularioDetails;
